var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.005,
    height: 14,
    viewBox: "0 0 14.005 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1065.587,458.4a1.407,1.407,0,0,0-1.978,0l-3.957,3.957-.658.659-.66-.659-3.956-3.957a1.4,1.4,0,0,0-1.978,1.978l3.957,3.956.659.66-.659.659-3.957,3.957a1.4,1.4,0,0,0,0,1.978,1.405,1.405,0,0,0,1.978,0l3.956-3.956.66-.66.658.66,3.957,3.956a1.406,1.406,0,0,0,1.978,0,1.4,1.4,0,0,0,0-1.978l-3.957-3.957-.657-.659.657-.66,3.957-3.956A1.4,1.4,0,0,0,1065.587,458.4Z",
    transform: "translate(-1051.99 -457.997)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossX);
export default __webpack_public_path__ + "static/media/cross-x.0e91a7e35163b65bea5f51933c75bcf9.svg";
export { ForwardRef as ReactComponent };